.productImage {
  width: 100%;
  height: 400px;
  border-radius: 20px;
  corner-shape: superellipse(1.18);
  object-fit: cover;
  cursor: pointer;
  transition: 0.5s;
}
.productImage:hover {
  opacity: 0.8;
}

.productName {
  font-size: 20px;
  font-weight: 300;
  text-decoration: none;
  color: #505050;
  margin-bottom: 0;
}
.productName:hover {
  color: #505050;
}

.titleRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.productDescriptionSecondLine {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dimensions {
  font-size: 16px;
}

.priceAndCTA {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.price {
  /* color: #f46d5e; */
  color: #ff8a65;
  font-size: 20px;
  font-weight: 300;
}
